import React, { useEffect } from 'react'

import Header from '../../../components/Turkey/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Turkey/PageTitle/PageTitle'
import Footer from '../../../components/Turkey/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import ContactContent from '../../../components/ContactContent/ContactContent'

export default function Contact() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={'contact'} />
      <UnderHeader className={'contact'} />
      <PageTitle mainTitle={'İLETİŞİM'} page={'İLETİŞİM'} />
      <ContactContent />
      <LogoPartner />
      <Footer />
    </div>
  )
}
